(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s23-animated-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('s23-memory-home')) {
    customElements.define('s23-memory-home', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        
        this.cards = [...this.querySelectorAll('[data-story]')];
        
        
        this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.entries = this.cards.map(card => {
          const video = card.querySelector('video');
          const button = card.querySelector('.s23-memory__playback');
          const entry = { card, video, button, visible: false, userPaused: false, userStarted: false };
          video.muted = true;
          video.defaultMuted = true;
          // Remove 1.8 seconds of the unchanged letter-design hold,
          // preserving the opening photograph and original sweatshirt dissolve.
          if (card.dataset.story === '0') {
            video.addEventListener('timeupdate', () => {
              if (!video.seeking && video.currentTime >= 3.1 && video.currentTime < 4.9) {
                video.currentTime = 4.9;
              }
            }, options);
          }
          video.controls = false;
          button.hidden = false;
          const sync = () => {
            button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
            button.querySelector('[data-playback-label]').textContent = video.paused ? button.dataset.playShort : button.dataset.pauseShort;
            button.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
          };
          video.addEventListener('play', sync, options);
          video.addEventListener('pause', sync, options);
          button.addEventListener('click', () => {
            if (video.paused) {
              entry.userPaused = false;
              entry.userStarted = true;
              video.play().catch(sync);
            } else {
              entry.userPaused = true;
              video.pause();
            }
          }, options);
          return entry;
        });
        this.refresh = () => { this.playVisible(); };
        this.reduced.addEventListener('change', this.refresh, options);
        document.addEventListener('visibilitychange', () => this.playVisible(), options);
        this.observer = new IntersectionObserver(items => {
          items.forEach(item => {
            const entry = this.entries.find(entry => entry.video === item.target);
            entry.visible = item.isIntersecting && item.intersectionRatio >= .35;
          });
          this.playVisible();
        }, { threshold: [0, .35] });
        this.classList.add('is-enhanced');
        this.entries.forEach(entry => this.observer.observe(entry.video));
      }
      playVisible() {
        this.entries.forEach(entry => {
          const allow = entry.visible && !entry.card.hidden && !document.hidden && !entry.userPaused && (!this.reduced.matches || entry.userStarted);
          if (allow) entry.video.play().catch(() => {});
          else entry.video.pause();
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.entries?.forEach(entry => entry.video.pause());
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
